(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("uK0kx", function(module, exports) {

var $38kyy = parcelRequire("38kyy");

var $2thha = parcelRequire("2thha");

var $05c67cf5129a5847$var$w = typeof window === 'undefined' ? (parcelRequire("foUwZ")) : window;
var $05c67cf5129a5847$var$document = $05c67cf5129a5847$var$w.document;
var $05c67cf5129a5847$var$Text = $05c67cf5129a5847$var$w.Text;
function $05c67cf5129a5847$var$context() {
    var cleanupFuncs = [];
    function h() {
        var args = [].slice.call(arguments), e = null;
        function item(l) {
            var r;
            function parseClass(string) {
                // Our minimal parser doesn’t understand escaping CSS special
                // characters like `#`. Don’t use them. More reading:
                // https://mathiasbynens.be/notes/css-escapes .
                var m = $38kyy(string, /([\.#]?[^\s#.]+)/);
                if (/^\.|#/.test(m[1])) e = $05c67cf5129a5847$var$document.createElement('div');
                $05c67cf5129a5847$var$forEach(m, function(v) {
                    var s = v.substring(1, v.length);
                    if (!v) return;
                    if (!e) e = $05c67cf5129a5847$var$document.createElement(v);
                    else if (v[0] === '.') $2thha(e).add(s);
                    else if (v[0] === '#') e.setAttribute('id', s);
                });
            }
            if (l == null) ;
            else if ('string' === typeof l) {
                if (!e) parseClass(l);
                else e.appendChild(r = $05c67cf5129a5847$var$document.createTextNode(l));
            } else if ('number' === typeof l || 'boolean' === typeof l || l instanceof Date || l instanceof RegExp) e.appendChild(r = $05c67cf5129a5847$var$document.createTextNode(l.toString()));
            else if ($05c67cf5129a5847$var$isArray(l)) $05c67cf5129a5847$var$forEach(l, item);
            else if ($05c67cf5129a5847$var$isNode(l)) e.appendChild(r = l);
            else if (l instanceof $05c67cf5129a5847$var$Text) e.appendChild(r = l);
            else if ('object' === typeof l) for(var k in l){
                if ('function' === typeof l[k]) {
                    if (/^on\w+/.test(k)) (function(k, l) {
                        if (e.addEventListener) {
                            e.addEventListener(k.substring(2), l[k], false);
                            cleanupFuncs.push(function() {
                                e.removeEventListener(k.substring(2), l[k], false);
                            });
                        } else {
                            e.attachEvent(k, l[k]);
                            cleanupFuncs.push(function() {
                                e.detachEvent(k, l[k]);
                            });
                        }
                    })(k, l);
                    else {
                        // observable
                        e[k] = l[k]();
                        cleanupFuncs.push(l[k](function(v) {
                            e[k] = v;
                        }));
                    }
                } else if (k === 'style') {
                    if ('string' === typeof l[k]) e.style.cssText = l[k];
                    else for(var s in l[k])(function(s, v) {
                        if ('function' === typeof v) {
                            // observable
                            e.style.setProperty(s, v());
                            cleanupFuncs.push(v(function(val) {
                                e.style.setProperty(s, val);
                            }));
                        } else var match = l[k][s].match(/(.*)\W+!important\W*$/);
                        if (match) e.style.setProperty(s, match[1], 'important');
                        else e.style.setProperty(s, l[k][s]);
                    })(s, l[k][s]);
                } else if (k === 'attrs') for(var v in l[k])e.setAttribute(v, l[k][v]);
                else if (k.substr(0, 5) === "data-") e.setAttribute(k, l[k]);
                else e[k] = l[k];
            }
            else if ('function' === typeof l) {
                //assume it's an observable!
                var v = l();
                e.appendChild(r = $05c67cf5129a5847$var$isNode(v) ? v : $05c67cf5129a5847$var$document.createTextNode(v));
                cleanupFuncs.push(l(function(v) {
                    if ($05c67cf5129a5847$var$isNode(v) && r.parentElement) r.parentElement.replaceChild(v, r), r = v;
                    else r.textContent = v;
                }));
            }
            return r;
        }
        while(args.length)item(args.shift());
        return e;
    }
    h.cleanup = function() {
        for(var i = 0; i < cleanupFuncs.length; i++)cleanupFuncs[i]();
        cleanupFuncs.length = 0;
    };
    return h;
}
var $05c67cf5129a5847$var$h = module.exports = $05c67cf5129a5847$var$context();
$05c67cf5129a5847$var$h.context = $05c67cf5129a5847$var$context;
function $05c67cf5129a5847$var$isNode(el) {
    return el && el.nodeName && el.nodeType;
}
function $05c67cf5129a5847$var$forEach(arr, fn) {
    if (arr.forEach) return arr.forEach(fn);
    for(var i = 0; i < arr.length; i++)fn(arr[i], i);
}
function $05c67cf5129a5847$var$isArray(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
}

});
parcelRegister("38kyy", function(module, exports) {
/*!
 * Cross-Browser Split 1.1.1
 * Copyright 2007-2012 Steven Levithan <stevenlevithan.com>
 * Available under the MIT License
 * ECMAScript compliant, uniform cross-browser split method
 */ /**
 * Splits a string into an array of strings using a regex or string separator. Matches of the
 * separator are not included in the result array. However, if `separator` is a regex that contains
 * capturing groups, backreferences are spliced into the result each time `separator` is matched.
 * Fixes browser bugs compared to the native `String.prototype.split` and can be used reliably
 * cross-browser.
 * @param {String} str String to split.
 * @param {RegExp|String} separator Regex or string to use for separating the string.
 * @param {Number} [limit] Maximum number of items to include in the result array.
 * @returns {Array} Array of substrings.
 * @example
 *
 * // Basic use
 * split('a b c d', ' ');
 * // -> ['a', 'b', 'c', 'd']
 *
 * // With limit
 * split('a b c d', ' ', 2);
 * // -> ['a', 'b']
 *
 * // Backreferences in result array
 * split('..word1 word2..', /([a-z]+)(\d+)/i);
 * // -> ['..', 'word', '1', ' ', 'word', '2', '..']
 */ module.exports = function split(undef) {
    var nativeSplit = String.prototype.split, compliantExecNpcg = /()??/.exec("")[1] === undef, // NPCG: nonparticipating capturing group
    self;
    self = function(str, separator, limit) {
        // If `separator` is not a regex, use `nativeSplit`
        if (Object.prototype.toString.call(separator) !== "[object RegExp]") return nativeSplit.call(str, separator, limit);
        var output = [], flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.extended ? "x" : "") + // Proposed for ES6
        (separator.sticky ? "y" : ""), // Firefox 3+
        lastLastIndex = 0, // Make `global` and avoid `lastIndex` issues by working with a copy
        separator = new RegExp(separator.source, flags + "g"), separator2, match, lastIndex, lastLength;
        str += ""; // Type-convert
        if (!compliantExecNpcg) // Doesn't need flags gy, but they don't hurt
        separator2 = new RegExp("^" + separator.source + "$(?!\\s)", flags);
        /* Values for `limit`, per the spec:
     * If undefined: 4294967295 // Math.pow(2, 32) - 1
     * If 0, Infinity, or NaN: 0
     * If positive number: limit = Math.floor(limit); if (limit > 4294967295) limit -= 4294967296;
     * If negative number: 4294967296 - Math.floor(Math.abs(limit))
     * If other: Type-convert, then use the above rules
     */ limit = limit === undef ? 4294967295 : limit >>> 0; // ToUint32(limit)
        while(match = separator.exec(str)){
            // `separator.lastIndex` is not reliable cross-browser
            lastIndex = match.index + match[0].length;
            if (lastIndex > lastLastIndex) {
                output.push(str.slice(lastLastIndex, match.index));
                // Fix browsers whose `exec` methods don't consistently return `undefined` for
                // nonparticipating capturing groups
                if (!compliantExecNpcg && match.length > 1) match[0].replace(separator2, function() {
                    for(var i = 1; i < arguments.length - 2; i++)if (arguments[i] === undef) match[i] = undef;
                });
                if (match.length > 1 && match.index < str.length) Array.prototype.push.apply(output, match.slice(1));
                lastLength = match[0].length;
                lastLastIndex = lastIndex;
                if (output.length >= limit) break;
            }
            if (separator.lastIndex === match.index) separator.lastIndex++; // Avoid an infinite loop
        }
        if (lastLastIndex === str.length) {
            if (lastLength || !separator.test("")) output.push("");
        } else output.push(str.slice(lastLastIndex));
        return output.length > limit ? output.slice(0, limit) : output;
    };
    return self;
}();

});

parcelRegister("2thha", function(module, exports) {
// contains, add, remove, toggle

var $73aJM = parcelRequire("73aJM");
module.exports = $1ccbb0db48077047$var$ClassList;
function $1ccbb0db48077047$var$ClassList(elem) {
    var cl = elem.classList;
    if (cl) return cl;
    var classList = {
        add: add,
        remove: remove,
        contains: contains,
        toggle: toggle,
        toString: $toString,
        length: 0,
        item: item
    };
    return classList;
    function add(token) {
        var list = getTokens();
        if ($73aJM(list, token) > -1) return;
        list.push(token);
        setTokens(list);
    }
    function remove(token) {
        var list = getTokens(), index = $73aJM(list, token);
        if (index === -1) return;
        list.splice(index, 1);
        setTokens(list);
    }
    function contains(token) {
        return $73aJM(getTokens(), token) > -1;
    }
    function toggle(token) {
        if (contains(token)) {
            remove(token);
            return false;
        } else {
            add(token);
            return true;
        }
    }
    function $toString() {
        return elem.className;
    }
    function item(index) {
        var tokens = getTokens();
        return tokens[index] || null;
    }
    function getTokens() {
        var className = elem.className;
        return $1ccbb0db48077047$var$filter(className.split(" "), $1ccbb0db48077047$var$isTruthy);
    }
    function setTokens(list) {
        var length = list.length;
        elem.className = list.join(" ");
        classList.length = length;
        for(var i = 0; i < list.length; i++)classList[i] = list[i];
        delete list[length];
    }
}
function $1ccbb0db48077047$var$filter(arr, fn) {
    var ret = [];
    for(var i = 0; i < arr.length; i++)if (fn(arr[i])) ret.push(arr[i]);
    return ret;
}
function $1ccbb0db48077047$var$isTruthy(value) {
    return !!value;
}

});
parcelRegister("73aJM", function(module, exports) {
var $52212469f058390b$var$indexOf = [].indexOf;
module.exports = function(arr, obj) {
    if ($52212469f058390b$var$indexOf) return arr.indexOf(obj);
    for(var i = 0; i < arr.length; ++i){
        if (arr[i] === obj) return i;
    }
    return -1;
};

});


parcelRegister("foUwZ", function(module, exports) {
"use strict";

});



var $uK0kx = parcelRequire("uK0kx");
var $d4b604744f5610ab$exports = {};
$d4b604744f5610ab$exports = [
    {
        "title": "\u0130nsan Kaynaklar\u0131 Y\xf6netimi Dan\u0131\u015Fmanl\u0131\u011F\u0131",
        "text": "Globalle\u015Fme sonucu h\u0131zla de\u011Fi\u015Fen rekabet ortam\u0131 ve teknolojinin geli\u015Fimi bilginin kolay ula\u015F\u0131labilir hale gelmesi ve bir\xe7ok i\u015Fletmenin benzer teknolojik altyap\u0131ya sahip olmas\u0131 i\u015Fletmeler i\xe7in daha g\xfc\xe7l\xfc insan fakt\xf6r\xfcn\xfc \xf6n plana \xe7\u0131karm\u0131\u015Ft\u0131r. Fikri sermayenin en \xf6nemli ve de\u011Ferli sermaye olmas\u0131 ile birlikte i\u015Fe al\u0131m, e\u011Fitim, performans, kariyer y\xf6netimi, \xfccret sistemlerinin de\u011Feri artmaktad\u0131r.",
        "list": [
            "\u0130nsan Kaynaklar\u0131 Y\xf6netimi Sisteminin Olu\u015Fturulmas\u0131",
            "\u0130nsan Kaynaklar\u0131 Planlamas\u0131 Ve Kariyer Yol Haritas\u0131n\u0131n Olu\u015Fturulmas\u0131",
            "\u0130\u015F Ak\u0131\u015Flar\u0131 Ve \u0130\u015F Analizleri Olu\u015Fturulmas\u0131, De\u011Ferlendirilmesi",
            "G\xf6rev Tan\u0131mlar\u0131n\u0131n Haz\u0131rlanmas\u0131 Ve Dok\xfcmantasyonu",
            "Norm Kadro  Ve Organizasyon Yap\u0131s\u0131n\u0131n Olu\u015Fturulmas\u0131",
            "Se\xe7me Ve Yerle\u015Ftirme S\xfcre\xe7leri",
            "E\u011Fitim Ve Geli\u015Fim S\xfcre\xe7leri",
            "Performans Y\xf6netimi S\xfcre\xe7leri",
            "Yetenek Y\xf6netimi S\xfcre\xe7leri",
            "\xdccret Y\xf6netimi Ve Yan Haklar Sistemi",
            "\u0130nsan Kaynaklar\u0131 Bilgi Sistemi"
        ]
    },
    {
        "title": "Personel Se\xe7me ve Yerle\u015Ftirme",
        "text": "\u0130\u015F hayat\u0131nda ba\u015Far\u0131l\u0131 olabilmenin temel yollar\u0131ndan birisi insan g\xfcc\xfcn\xfc do\u011Fru pozisyonda kullanmakt\u0131r. Beyond to Human olarak, personel se\xe7me ve yerle\u015Ftirme hizmeti ile profesyonel insan g\xfcc\xfcn\xfc bulmak, bu g\xfcc\xfc do\u011Fru yerde ve en do\u011Fru bi\xe7imde m\xfc\u015Fteri firmalar\u0131 ad\u0131na de\u011Ferlendirme ve y\xf6netmeyi temel ilke olarak benimsemi\u015Ftir.",
        "list": [
            "Firma Analizi M\xfc\u015Fteri firma k\xfclt\xfcr\xfc ve hedeflerinin tespiti M\xfc\u015Fteri firma, aday profili ve pozisyon analizi, gerekli g\xf6r\xfcld\xfc\u011F\xfc takdirde ilgili birim y\xf6neticisi ile birebir g\xf6r\xfc\u015Fmeler yap\u0131larak detay beklentiler belirlenir.",
            "Projenin ihtiya\xe7lar\u0131na ve firman\u0131n belirlenen stratejilerine ba\u011Fl\u0131 olarak ilanlar haz\u0131rlan\u0131r.",
            "Aday Profili ve Pozisyon Analizi Aday havuzunun olu\u015Fturulmas\u0131 ve uygun \xf6zge\xe7mi\u015Flerin bulunmas\u0131, Aday Havuzu; Beyond to Human olarak do\u011Frudan ara\u015Ft\u0131rma, ilan verme y\xf6ntemleriyle belirlenir.",
            "\xd6n Eleme M\xfclakatlar\u0131n\u0131n Ger\xe7ekle\u015Ftirilmesi \xd6zge\xe7mi\u015F \xf6n de\u011Ferlendirmeleri ve m\xfclakat davetleri  yap\u0131l\u0131r, Yetkinlik bazl\u0131 bireysel veya  grup m\xfclakatlar\u0131 tamamlan\u0131r.",
            "Olumlu Adaylar\u0131n Firma\u2019ya Sunumu Adaylar\u0131n m\xfc\u015Fteri firmaya y\xf6nlendirilmesi organizasyonu, CV bilgilerinin raporlanmas\u0131",
            "Referans Kontrol\xfc Referanslar\u0131n kontrol\xfc, aday\u0131n \xf6nceki i\u015F deneyimleri ile ilgili 360\xb0 referans ara\u015Ft\u0131rmas\u0131 yap\u0131larak  aday\u0131n hakk\u0131nda bilgiler raporlanmaktad\u0131r.",
            "\u0130\u015F g\xf6r\xfc\u015Fmelerinin ard\u0131ndan detayl\u0131 referans ara\u015Ft\u0131rmalar\u0131 ger\xe7ekle\u015Ftirilerek s\xfcre\xe7 tamamlan\u0131r ve talep edilirse adaya teklif yap\u0131l\u0131r.",
            "Teklif ve \u0130\u015Fe Ba\u015Flama \u0130\u015Fe ba\u015Flama tarihinin kurum ve aday taraf\u0131ndan teyidi sa\u011Flan\u0131r ve s\xfcre\xe7 izlenerek Proje tamamlan\u0131r. Onay g\xf6r\xfc\u015Fmesi tamamland\u0131ktan sonra i\u015Fe giri\u015F evraklar\u0131n\u0131n takibi yap\u0131l\u0131r.",
            "Yerle\u015Fen Aday\u0131n Kariyer Takibi 3, 6 ve 12 ayl\u0131k d\xf6nemlerle, adaylar\u0131n firmalardaki memnuniyeti \xf6l\xe7\xfclmektedir."
        ]
    },
    {
        "title": "E\u011Fitim ve Geli\u015Fim S\xfcreci Dan\u0131\u015Fmanl\u0131\u011F\u0131",
        "text": "Yo\u011Fun rekabet ortam\u0131nda, firmalar\u0131n, etkin ve verim art\u0131r\u0131c\u0131 amac\u0131n\u0131 \u015Firketin misyonuna ve y\xf6netimlerinin beklentilerine uygun olarak tasarlanmas\u0131n\u0131 sa\u011Flamakt\u0131r. Ve ihtiyaca dayal\u0131 bir e\u011Fitim ve geli\u015Fim y\xf6netimi s\xfcrecinin kurulmas\u0131 amac\u0131 ile ba\u015Fta e\u011Fitim ihtiya\xe7 analizi, e\u011Fitim uygulamalar\u0131, e\u011Fitim sonras\u0131 etkinlik de\u011Ferlendirme konular\u0131 olmak \xfczere, insan kaynaklar\u0131 y\xf6netimi s\xfcre\xe7leri ile ili\u015Fkilendirerek en do\u011Fru hizmeti profesyonel olarak birlikte kurguluyoruz.",
        "list": [
            "E\u011Fitim & Geli\u015Fim S\xfcreci Dan\u0131\u015Fmanl\u0131\u011F\u0131 Hizmetlerimiz",
            "E\u011Fitim & Geli\u015Fim Y\xf6netimi S\xfcreci",
            "E\u011Fitim & Geli\u015Fim \u0130htiya\xe7 Analizi",
            "Yetkinlikler ve E\u011Fitim \u0130htiya\xe7 Analizi \u0130li\u015Fkisi",
            "\u015Eirket Stratejik Hedefleri, \xc7al\u0131\u015Fan hedefleri ve e\u011Fitim ihtiya\xe7 analizi ili\u015Fkisi",
            "E\u011Fitim ve Geli\u015Fim \u0130htiya\xe7 Analizi Verilerinin Kullan\u0131m\u0131-Entegre \u0130K Sistemleri \u0130\xe7erisindeki Yeri",
            "E\u011Fitim B\xfct\xe7esinin Haz\u0131rlanmas\u0131",
            "Kurum i\xe7i E\u011Fitim & Geli\u015Fim Katalo\u011Funun Olu\u015Fturulmas\u0131",
            "E\u011Fitimin De\u011Ferlendirilmesi ve ROI\u2019si",
            "E\u011Fitimde \xd6l\xe7me ve De\u011Ferlendirme Kriterleri",
            "E\u011Fitimin Etkinli\u011Fi",
            "Modern Organizasyon ve \u0130\u015Fletme Teorileri A\xe7\u0131s\u0131ndan E\u011Fitimin Etkinli\u011Fi Modeli",
            "E\u011Fitim Etkinli\u011Finin De\u011Ferlendirme ROI Sisteminin Kurulmas\u0131 ve ROI S\xfcreci",
            "Kurumsal E\u011Fitim ve Geli\u015Fim Akademisi Kurulmas\u0131"
        ]
    },
    {
        "title": "Y\xf6netim Dan\u0131\u015Fmanl\u0131\u011F\u0131",
        "text": "Globalle\u015Fmenin getirdi\u011Fi yo\u011Fun ve ac\u0131mas\u0131z rekabet ortam\u0131, t\xfcm i\u015F kollar\u0131nda teknolojik ve yap\u0131sal h\u0131zl\u0131 de\u011Fi\u015Fimi de beraberinde getirmektedir. \u015Eirketin b\xfct\xfcn\xfc ile ilgili kararlar\u0131 salt i\xe7eriden bakarak vermek yerine, Ko\u015Fullar ve yeni f\u0131rsatlar / tehditler olu\u015Fturan d\u0131\u015F \xe7evre etmenlerinin de analiz edilmesi zorunlu hale gelmi\u015Ftir.",
        "list": [
            "Strateji \xd6n A\u015Famas\u0131 \xc7al\u0131\u015Fmalar\u0131",
            "Misyon",
            "Vizyon",
            "Firman\u0131z\u0131n Uzun D\xf6nemli Davran\u0131\u015Flar\u0131n\u0131n Belirlenmesi",
            "Firman\u0131z\u0131n Ula\u015Fmak \u0130stedi\u011Fi Hedeflerinin Belirlenmesi",
            "Sekt\xf6r veya Sekt\xf6rlerin Analitik Y\xf6ntemlerle De\u011Ferlendirilmesi",
            "D\u0131\u015F \xc7evrenin Analitik Y\xf6ntemlerle De\u011Ferlendirilmesi"
        ]
    },
    {
        "title": "Ad\u0131m Ad\u0131m Kurumsal Check-up",
        "text": "\u015Eirketlerin uzun d\xf6nemde varl\u0131\u011F\u0131n\u0131 devam ettirebilmesi ve rekabet \xfcst\xfcnl\xfc\u011F\xfc elde edebilmesi sahip oldu\u011Fu yeteneklerle ilintilidir. Kurumsal check-up uygulamas\u0131 ile firman\u0131z\u0131n g\xfc\xe7l\xfc ve zay\u0131f yanlar\u0131n\u0131n tespiti \xfczerinden yola \xe7\u0131k\u0131larak; geli\u015Ftirilmesi gereken alanlar\u0131n\u0131, yeteneklerini tespit ederek, stratejik kararlar\u0131n\u0131z ve gelecek tasar\u0131m\u0131n\u0131z i\xe7in gerekli alt yap\u0131n\u0131n haz\u0131rlanmas\u0131 hedeflenmektedir.",
        "list": [
            "Mevcut organizasyon yap\u0131s\u0131",
            "Olmas\u0131 gereken organizasyon yap\u0131s\u0131",
            "Karar alma sistemleri",
            "\u0130nsan kayna\u011F\u0131 uygulamalar\u0131",
            "\u0130leti\u015Fim ve koordinasyon mekanizmalar\u0131",
            "Yol haritas\u0131"
        ]
    }
];


const $c7271ca19e1981f5$var$id = document.getElementById.bind(document);
const $c7271ca19e1981f5$var$params = new URLSearchParams(location.search);
const $c7271ca19e1981f5$var$q = parseInt($c7271ca19e1981f5$var$params.get('q'));
if (isNaN($c7271ca19e1981f5$var$q)) location = '/#hizmetler';
else {
    $c7271ca19e1981f5$var$id('app').appendChild((0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.section', (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.container', (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.columns', (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.column', (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.content.is-family-secondary', (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('h1', (0, (/*@__PURE__*/$parcel$interopDefault($d4b604744f5610ab$exports)))[$c7271ca19e1981f5$var$q].title), (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('p', (0, (/*@__PURE__*/$parcel$interopDefault($d4b604744f5610ab$exports)))[$c7271ca19e1981f5$var$q].text), (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('ul', (0, (/*@__PURE__*/$parcel$interopDefault($d4b604744f5610ab$exports)))[$c7271ca19e1981f5$var$q].list.map((value)=>(0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('li', value))))), (0, (/*@__PURE__*/$parcel$interopDefault($uK0kx)))('.column#form-parent')))));
    $c7271ca19e1981f5$var$id('form-parent').appendChild($c7271ca19e1981f5$var$id('form'));
    $c7271ca19e1981f5$var$id('form').classList.remove('is-hidden');
    $c7271ca19e1981f5$var$id('request').value = (0, (/*@__PURE__*/$parcel$interopDefault($d4b604744f5610ab$exports)))[$c7271ca19e1981f5$var$q].title;
}

})();
//# sourceMappingURL=hizmetler.js.map
